/**
 * Full screen element
 * 
 */
import { animatedScrollTo } from './AnimatedScrollTo';

export default class FullscreenElements {
    constructor(els) {
        if (els) {
            this.els = els;
            this.header = document.querySelector('.site-header');
            this.headerHeight = this.header.offsetHeight;
            this.logo = document.querySelector('.site-branding');
            this.logoHeight = this.logo.offsetHeight;
            const isHome = document.body.classList.contains('home');
            for (let i = 0; i < els.length; i++) {
                if (isHome) {
                    this.addDownArrow(els[i]);
                }
            }
        }
    }

    addDownArrow(el) {
        const arrow = document.createElement('span');
        arrow.classList.add('swiper-slide__down-arrow');
        arrow.innerHTML = '';
        el.appendChild(arrow);
        let num = parseInt(document.getElementById('main').offsetTop);
        arrow.addEventListener('click', function () {
            animatedScrollTo({
                to: '' + num
            });
        });
    }
}